<template>
  <section class="produccion-page">
    <b-card class="filters-card">
      <b-row class="g-1">
        <b-col cols="12" lg="3">
          <label class="filter-label">Servicio</label>
          <v-select
            v-model="filters.servicio"
            :options="servicios"
            label="text"
            placeholder="Todos"
            clearable
            :reduce="(option) => option.value"
            @input="onServicioChange"
          />
        </b-col>
        <b-col cols="12" lg="3">
          <label class="filter-label">Especialidad</label>
          <v-select
            v-model="filters.especialidad"
            :options="opsespecialidad"
            label="text"
            placeholder="Todos"
            :reduce="(option) => option"
          />
        </b-col>
        <b-col cols="12" lg="3">
          <label class="filter-label">Establecimiento</label>
          <v-select
            v-model="filters.establecimiento"
            :options="establecimientos"
            label="text"
            placeholder="Todos"
            :reduce="(option) => option"
          />
        </b-col>
      </b-row>
      <b-row class="g-1 mt-1">
        <b-col cols="12" lg="3">
          <label class="filter-label">Cobertura</label>
          <v-select
            v-model="filters.cobertura"
            :options="opsCobertura"
            label="text"
            placeholder="Todos"
            :reduce="(option) => option"
          />
        </b-col>
        <b-col cols="12" lg="3">
          <label class="filter-label">Desde</label>
          <flat-pickr
            v-model="filters.desde"
            placeholder="DD/MM/AAAA"
            :config="configdateTimePicker"
            class="form-control"
          />
        </b-col>
        <b-col cols="12" lg="3">
          <label class="filter-label">Hasta</label>
          <flat-pickr
            v-model="filters.hasta"
            placeholder="DD/MM/AAAA"
            :config="configdateTimePicker"
            class="form-control"
          />
        </b-col>
        <b-col cols="12" lg="3" class="d-flex align-items-end gap-1">
          <b-button variant="primary" class="w-100" @click="consultar">
            Buscar
          </b-button>
          <b-button
            variant="warning"
            class="w-100"
            @click="resetearFiltros"
            title="Limpiar filtros"
          >
            <i class="fa-solid fa-eraser" />
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-row class="mt-2">
      <b-col cols="12" lg="5">
        <b-card class="panel-card">
          <div v-if="mode === 'ranking'" class="chart-wrap">
            <BarChart
              ref="rankingChart"
              :chart-data="rankingChartData"
              :chart-options="rankingChartOptions"
              :chart-id="'ranking-chart'"
            />
          </div>
          <div v-else class="chart-wrap">
            <LineChart
              :chart-data="trendChartData"
              :chart-options="trendChartOptions"
              :chart-id="'trend-chart'"
            />
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" lg="7">
        <b-card class="panel-card">
          <div class="report-actions">
            <span>Reporte:</span>
            <b-button
              variant="outline-secondary"
              size="sm"
              title="Exportar Excel"
              @click="exportarCsv"
            >
              <i class="fas fa-file-excel" />
            </b-button>
            <b-button
              variant="outline-secondary"
              size="sm"
              title="Exportar PDF"
              @click="exportarPdf"
            >
              <i class="fa-solid fa-file-pdf" />
            </b-button>
          </div>
          <b-table
            small
            responsive
            :items="tableRows"
            :fields="tableFields"
            class="mb-0"
          />
        </b-card>
      </b-col>
    </b-row>

    <div class="results-count">Resultados: {{ tableRows.length }}</div>
  </section>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import { Bar, Line } from "vue-chartjs/legacy";
import vSelect from "vue-select";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "ServiciosMasSolicitados",
  components: {
    BarChart: Bar,
    LineChart: Line,
    flatPickr,
    vSelect,
  },
  data() {
    return {
      isLoading: false,
      mode: "ranking",
      filters: {
        servicio: "atencionmedica",
        especialidad: { value: "all", text: "Todos" },
        establecimiento: { value: "all", text: "Todos" },
        cobertura: { value: "all", text: "Todos" },
        desde: null,
        hasta: null,
      },
      servicios: [
        { value: "atencionmedica", text: "Atención Médica" },
        { value: "farmaco", text: "Fármaco" },
        { value: "insumos", text: "Insumos" },
        { value: "terapias", text: "Terapias" },
        { value: "examenes_laboratorio", text: "Laboratorio" },
        { value: "imagenes", text: "Imágenes" },
        { value: "procesoclinico", text: "Proceso Clínico" },
      ],
      opsespecialidad: [{ value: "all", text: "Todos" }],
      opsCobertura: [
        { value: "all", text: "Todos" },
        { value: "1", text: "IESS" },
        { value: "2", text: "ISSPOL" },
        { value: "3", text: "ISSFA" },
        { value: "4", text: "MSP" },
        { value: "5", text: "PARTICULAR" },
      ],
      establecimientos: [{ value: "all", text: "Todos" }],
      table: {
        page: 1,
        perPage: 10,
      },
      rankingData: {
        labels: [],
        values: [],
        table: [],
      },
      trendData: {
        series: [],
        x: [],
        table: [],
      },
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "d/m/Y",
        locale: Spanish,
      },
    };
  },
  computed: {
    tableFields() {
      if (this.mode === "ranking") {
        return [
          { key: "servicio", label: "Servicio" },
          { key: "establecimiento", label: "Establecimiento" },
          { key: "descripcion", label: "Descripción" },
          { key: "cantidad", label: "Cantidad" },
          { key: "precio_unitario", label: "Precio unitario" },
          { key: "ingresos", label: "Total" },
        ];
      }
      return [
        { key: "sucursal", label: "Sucursal" },
        { key: "cantidad", label: "Cantidad" },
        { key: "ingresos", label: "Ingresos" },
      ];
    },
    tableRows() {
      const rows =
        this.mode === "ranking" ? this.rankingData.table : this.trendData.table;

      if (this.mode !== "ranking") {
        return rows;
      }

      const normalized = rows.map((row) => ({
        ...row,
        servicio: this.normalizeServicio(row?.servicio),
        establecimiento: this.normalizeEstablecimiento(row?.establecimiento),
        ingresos: this.formatCurrency(row?.ingresos),
      }));

      return normalized
        .sort((a, b) => {
          const aVal = Number(a?.cantidad) || 0;
          const bVal = Number(b?.cantidad) || 0;
          return bVal - aVal;
        })
        .slice(0, this.table.perPage);
    },
    rankingChartData() {
      const entries = this.rankingData.labels.map((label, index) => ({
        label: this.normalizeServicio(label),
        value: Number(this.rankingData.values[index]) || 0,
      }));

      const top = entries
        .sort((a, b) => b.value - a.value)
        .slice(0, this.table.perPage);

      return {
        labels: top.map((item) => item.label),
        datasets: [
          {
            label: "Solicitudes",
            data: top.map((item) => item.value),
            backgroundColor: "#4C78A8",
            borderRadius: 6,
          },
        ],
      };
    },
    rankingChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          title: { display: false },
        },
        scales: {
          x: { ticks: { color: "#5A6B82" } },
          y: { ticks: { color: "#5A6B82" } },
        },
        onClick: this.handleRankingClick,
      };
    },
    trendChartData() {
      return {
        labels: this.trendData.x,
        datasets: this.trendData.series.map((serie, index) => ({
          label: serie.name || `Serie ${index + 1}`,
          data: serie.data || [],
          borderColor: this.pickColor(index),
          backgroundColor: "transparent",
          borderWidth: 2,
          pointRadius: 3,
          pointHoverRadius: 5,
          tension: 0.25,
        })),
      };
    },
    trendChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: "bottom" },
          title: { display: false },
        },
        scales: {
          x: { ticks: { color: "#5A6B82" } },
          y: { ticks: { color: "#5A6B82" } },
        },
      };
    },
  },
  watch: {
    "filters.servicio": {
      handler() {
        if (!this.filters.servicio) {
          this.filters.servicio = "atencionmedica";
        }
      },
    },
  },
  mounted() {
    this.fetchEstablecimientos();
    this.fetchEspecialidades();
  },
  methods: {
    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        const rows = response?.data?.data?.allEstablecimientos || [];
        this.establecimientos = [
          { value: "all", text: "Todos" },
          ...rows.map((item) => ({
            value: item.id,
            text: item.Descripcion,
            uniCodigo: item.uniCodigo,
          })),
        ];
      } catch (error) {
        this.establecimientos = [{ value: "all", text: "Todos" }];
      }
    },
    async fetchEspecialidades() {
      const query = `
        query {
          allEspecialidad {
            id
            descripcion
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        const rows = response?.data?.data?.allEspecialidad || [];
        this.opsespecialidad = [
          { value: "all", text: "Todos" },
          ...rows.map((item) => ({
            value: item.id,
            text: item.descripcion,
          })),
        ];
      } catch (error) {
        this.opsespecialidad = [{ value: "all", text: "Todos" }];
      }
    },
    pickColor(index) {
      const palette = ["#4C78A8", "#F58518", "#54A24B", "#E45756", "#72B7B2"];
      return palette[index % palette.length];
    },
    normalizeServicio(value) {
      if (!value) return value;
      const text = String(value).toLowerCase();

      if (text.includes("examen") || text.includes("laboratorio")) {
        return "Laboratorio";
      }
      if (text.includes("atencion") || text.includes("medica")) {
        return "Atención Médica";
      }
      if (text.includes("procesoclinico") || text.includes("proceso")) {
        return "Proceso Clínico";
      }
      if (text.includes("imagen")) {
        return "Imágenes";
      }
      if (text.includes("farmaco")) {
        return "Fármaco";
      }
      if (text.includes("insumo")) {
        return "Insumos";
      }
      if (text.includes("terapia")) {
        return "Terapias";
      }

      return value;
    },
    formatCurrency(value) {
      const num = Number(value);
      if (Number.isNaN(num)) return value;
      return num.toFixed(2);
    },
    normalizeEstablecimiento(value) {
      if (!value) return value;
      if (typeof value === "string") return value;
      return (
        value.text ||
        value.descripcion ||
        value.Descripcion ||
        value.nombre ||
        value.name ||
        ""
      );
    },
    async consultar() {
      this.isLoading = true;
      try {
        const query = `
          query ServiciosMasSolicitados(
            $servicio: String
            $especialidad: ID
            $establecimiento: ID
            $cobertura: String
            $desde: String
            $hasta: String
            $page: Int
            $perPage: Int
          ) {
            serviciosMasSolicitados(
              servicio: $servicio
              especialidad: $especialidad
              establecimiento: $establecimiento
              cobertura: $cobertura
              desde: $desde
              hasta: $hasta
              page: $page
              perPage: $perPage
            ) {
              mode
              labels
              values
              x
              series {
                name
                data
              }
              table {
                servicio
                establecimiento
                descripcion
                cantidad
                precio_unitario
                ingresos
              }
              pageInfo {
                total
                page
                perPage
                totalPages
              }
            }
          }
        `;

        const variables = {
          servicio: this.filters.servicio || "all",
          especialidad: this.filters.especialidad?.value || "all",
          establecimiento: this.filters.establecimiento?.value || "all",
          cobertura: this.filters.cobertura?.value || "all",
          desde: this.filters.desde,
          hasta: this.filters.hasta,
          page: this.table.page,
          perPage: this.table.perPage,
        };

        const response = await axios.post(rutas.axios + "api", {
          query,
          variables,
        });
        const payload =
          response?.data?.data?.serviciosMasSolicitados || {};
        this.mode = "ranking";
        this.rankingData = {
          labels: payload.labels || [],
          values: payload.values || [],
          table: payload.table || [],
        };
      } catch (error) {
        this.mode = "ranking";
      } finally {
        this.isLoading = false;
      }
    },
    handleRankingClick(event) {
      const chart = this.$refs.rankingChart?.chart;
      if (!chart) return;
      const points = chart.getElementsAtEventForMode(
        event,
        "nearest",
        { intersect: true },
        false
      );
      if (!points.length) return;
      const index = points[0].index;
      const label = this.rankingData.labels[index];
      if (!label) return;

      const existing = this.servicios.find((item) => item.text === label);
      if (existing) {
        this.filters.servicio = existing.value;
      } else {
        const newOption = { value: label, text: label };
        this.servicios = [...this.servicios, newOption];
        this.filters.servicio = label;
      }

      this.consultar();
    },
    exportarCsv() {
      const rows = this.tableRows || [];
      if (!rows.length) return;

      const headers = this.tableFields.map((field) => field.label);
      const keys = this.tableFields.map((field) => field.key);

      const csvLines = [
        headers.join(","),
        ...rows.map((row) =>
          keys
            .map((key) => {
              const value = row[key] == null ? "" : String(row[key]);
              return `"${value.replace(/\"/g, '""')}"`;
            })
            .join(",")
        ),
      ];

      const blob = new Blob([csvLines.join("\n")], {
        type: "text/csv;charset=utf-8;",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "servicios-mas-solicitados.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    exportarPdf() {
      // TODO: Implementar exportacion PDF cuando se habilite el backend.
    },
    resetearFiltros() {
      this.filters = {
        servicio: "atencionmedica",
        especialidad: { value: "all", text: "Todos" },
        establecimiento: { value: "all", text: "Todos" },
        cobertura: { value: "all", text: "Todos" },
        desde: null,
        hasta: null,
      };
    },
    onServicioChange(value) {
      if (value == null) {
        this.filters.servicio = "atencionmedica";
      }
    },
  },
};
</script>

<style scoped>
.produccion-page {
  padding: 1.5rem;
}

.filters-card {
  border-radius: 12px;
  border: 1px solid #e6e9ef;
  box-shadow: 0 8px 18px rgba(27, 39, 51, 0.08);
}

.filters-header {
  font-weight: 600;
  color: #223046;
  margin-bottom: 0.75rem;
}

.filter-label {
  font-size: 0.85rem;
  color: #5a6b82;
  margin-bottom: 0.35rem;
}

.panel-card {
  border-radius: 16px;
  border: none;
  box-shadow: 0 10px 24px rgba(20, 36, 60, 0.1);
}

.panel-title {
  font-weight: 600;
  color: #1e2a3a;
  margin-bottom: 1rem;
}

.report-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #3b4a5f;
  margin-bottom: 0.5rem;
}

.table-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

.chart-wrap {
  height: 320px;
}

.results-count {
  margin-top: 0.75rem;
  display: flex;
  justify-content: flex-end;
  font-weight: 600;
  color: #3b4a5f;
}

.g-1 > [class*="col"] {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

@media (max-width: 991px) {
  .chart-wrap {
    height: 260px;
  }
}
</style>
